import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormIf = () => (
  <ComponentDocs
    name="<Form.If/>"
    entry="FieldCondition"
    propsEntry="FieldConditionProps"
  >
    <ComponentExample
      name="Function condition"
      description="The condition prop can be passed a function to conditionally render content based on the state of the form"
      import={import("examples/Forms/FormIf/FunctionConditionExample")}
      rawImport={import("examples/Forms/FormIf/FunctionConditionExample?raw")}
    />
    <ComponentExample
      name="Boolean condition"
      description="The condition prop can be passed a boolean to conditionally render content based on some external state"
      import={import("examples/Forms/FormIf/BooleanConditionExample")}
      rawImport={import("examples/Forms/FormIf/BooleanConditionExample?raw")}
    />
    <ComponentExample
      name="Field match"
      description="The field and match props can be used together to conditionally render content based on a specific field value"
      import={import("examples/Forms/FormIf/FieldMatchExample")}
      rawImport={import("examples/Forms/FormIf/FieldMatchExample?raw")}
    />
  </ComponentDocs>
);

export default FormIf;
